<template>
    <div class="my-product" v-loading="loading">
        <tab-header
            :tabList="productTabList"
            :tabName="tabName"
            :isSort="false"
            :isCount="false"
            :isSelf="isSelf"
            @getTabName="getTabName">
        </tab-header>
        <section class="product-content"  v-loading="isLoading">
            <ul class="product-list" v-if="productList.length">
                <template v-for="(item, index) in productList">
                    <product
                        :key="index"
                        :productInfo="item"
                        :isPersonCenter="true"
                        @handleToggleCollect="handleToggleCollect">
                    </product>
                </template>
            </ul>
            <!-- 无数据 -->
            <div class="content-empty" v-show="!productList.length && !isLoading">
                <img src="../../images/personal_center/data-null.png" alt="" />
                <p>暂无数据</p>
            </div>
            <!-- 滚动加载loading -->
            <div class="load-more" v-if="isMoreLoading || productList.length">
                <img v-if="isMoreLoading" alt="loadding" src="../../images/common/loading_2_24x24.gif">
                <span v-else>{{ totalPage === curPage ? '没有更多内容了' : '显示更多' }}</span>
            </div>
        </section>
    </div>
</template>

<script>
import tabHeader from './tabHeader.vue'
import product from '../common/product.vue'
import personalCenter from '@/mixins/personalCenter.js'
export default {
    components: {
        tabHeader,
        product
    },
    mixins: [ personalCenter ],
    data () {
        return {
            productTabList: [
                {
                    label: '的作品',
                    name: 'my_product'
                },
                {
                    label: '关注的作品',
                    name: 'follow_product'
                }
            ],
            productList: [],
            tabName: 'my_product'
        }
    },
    methods: {
        // 切换tab
        getTabName (name) {
            this.tabName = name || 'my_product'
            this.curPage = 1
            this.getProductList()
        },
        // 我的作品列表
        async getProductList (isMore) {
            try {
                if (isMore) {
                    this.isMoreLoading = true
                } else {
                    this.isLoading = !this.loading
                }
                const url = this.tabName === 'my_product' ? `core/product/?user=${this.userId}` : `core/product/?liked_user=${this.userId}`
                await axios.get(myUrl + url, {
                    params: {
                        page: this.curPage
                    }
                }).then((res) => {
                    const resp = res.data
                    if (!resp.result) return
                    this.totalPage = Math.ceil(resp.data.count / 10) // 返回总页数
                    this.isPageOver = this.totalPage === this.curPage
                    const prodcutList = resp.data.results
                    if (isMore) {
                        this.productList.push(...prodcutList)
                    } else {
                        this.productList = prodcutList
                    }
                })
            } catch (error) {
                console.warn(error)
            } finally {
                this.loading = false
                this.isLoading = false
                this.isMoreLoading = false
            }
        },
        // 取消关注
        handleToggleCollect (appId) {
            const index = this.productList.find(item => item.app_id === appId)
            this.productList.splice(index, 1)
        },
        // 监听滚动
        handleScroll () {
            this.scrollLoading(this.getProductList, false)
        }
    }
}
</script>

<style lang="scss">
    .product-list .product-item {
        &:nth-child(3n) {
            margin-right: 0 !important;
        }
        .product-desc {
            -webkit-line-clamp: 3 !important;
        }
    }
    .my-product {
        .el-loading-mask {
            .el-loading-spinner {
                top: 170px !important;
            }
        }
    }
</style>
<style lang="scss" scoped>
    .my-product {
        width: 1200px;
        margin: 0 auto 17px;
        background: #fff;
        padding-bottom: 20px;
        .product-content {
            min-height: 320px;
        }
        .product-list {
            display: flex;
            flex-wrap: wrap;
            padding: 24px 19px 0px 20px;
        }
    }
</style>


// WEBPACK FOOTER //
// my_product.vue?ef2da070